var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeutron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8136_7850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9999 0H1.69736L8.2501 7.72796C9.25087 6.84889 10.5631 6.31586 11.9998 6.31586C15.139 6.31586 17.684 8.86077 17.684 12.0001C17.684 13.4122 17.1691 14.704 16.3166 15.6982L23.9999 22.3421V24V0ZM21.1183 24L15.0242 16.8138C14.1482 17.3652 13.1113 17.6842 11.9998 17.6842C8.8605 17.6842 6.3156 15.1394 6.3156 12.0001C6.3156 10.8949 6.63098 9.8634 7.17667 8.99068L0 2.80263V24H21.1183Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8136_7850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutron);
export default __webpack_public_path__ + "static/media/neutron.9de38e0cf1eeb65e1d5024b428976336.svg";
export { ForwardRef as ReactComponent };